import { useQuery } from 'react-query';

import { Capability, PermissionScope, QueryKey } from '@ge/models/constants';
import { Config, useAuth } from '@ge/shared/data-hooks';

import { fetchTaskDelayScope } from '../services/task-template';

export const useTaskDelayScope = () => {
  const { isAuthorized } = useAuth();
  const isAuthorizedToGetTasks = isAuthorized({
    capabilities: [{ capability: Capability.FIELD_TASKS, scopes: [PermissionScope.VIEW] }],
  });
  return useQuery([QueryKey.TASK_DELAY_SCOPES], () => fetchTaskDelayScope(), {
    enabled: isAuthorizedToGetTasks,
    ...Config.EXECUTE_ONCE,
  });
};
